import { Col, Row, Container, Card, CardBody, CardHeader, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"

import BarChar1 from "./BarChart1";
import HighChart from "./HighChart";
import BarChart2 from "./BarChart2";
import PieCharts from "./PieChart";
import LoadingChart from "./ProgressBar";
import DateTimePicker from 'react-datepicker'
import { useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { br } from "@fullcalendar/core/internal-common";

const Dashboard = () => {

  const [fromDateTime, setFromDateTime] = useState(null)
  const [toDateTime, setToDateTime] = useState(null)



  const [generateKey, setGenerateKey] = useState<number>(0)
 



  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 6); 
  startDate.setHours(0, 0, 0, 0);


  

  const handleGenerate = () => {
    setGenerateKey(prev => prev + 1)
  }



  

  return (
      <>
       <br />
    <Container fluid='true' style={{ height: '100%' }}>
      <Row className="dashboard-header p-0 mb-2" style={{ marginLeft: '1px', height: '50px' }}>

        <div className="d-flex justify-content-between align-items-center">



          <h4 style={{ fontWeight: '600' }}>Dashboard</h4>

          <div className='d-flex justify-around'>

            <div className=" mx-2  d-flex flex-column ">

              <DateTimePicker
                className="dashboard-input"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setFromDateTime(date)}
                selected={fromDateTime ? fromDateTime : startDate}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>


            <div className=" mx-2  d-flex flex-column">

              <DateTimePicker
                className="dashboard-input"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setToDateTime(date)}
                selected={toDateTime ? toDateTime : endDate}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>
            <div>

              <Button color="success" className="button-dashboard mx-2 px-1 py-1" onClick={handleGenerate}>
                Generate
              </Button>

            </div>
          </div>


        </div>


      </Row>
      <Row   style={{maxHeight:'465px'}} >
        <Col xl={7} className="m-0" >
          <BarChar1 
            fromDateTime={fromDateTime} toDateTime={toDateTime} generateKey={generateKey}
           />

        </Col>

        <Col xl={5} >
          <HighChart  fromDateTime={fromDateTime} toDateTime={toDateTime} generateKey={generateKey} />
        </Col>
      </Row>
      <Row>
        <Col xl={8} className="mb-1">
          <BarChart2 fromDateTime={fromDateTime} toDateTime={toDateTime} generateKey={generateKey}/>
        </Col>
       
        <Col md={4}>
          <LoadingChart  fromDateTime={fromDateTime} toDateTime={toDateTime} generateKey={generateKey}/>
        </Col>
      </Row>
    </Container>
    </>
  )
}

export default Dashboard;